module.exports = __webpack_public_path__ + "img/PCl3_Structures.9324c38c.png";